import { Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import Header from "./components/Header";
import DesignerPage from "./routes/DesignerPage";
import FormPage from "./routes/FormPage";
import ViewerPage from "./routes/ViewerPage";
import TemplateListPage from "./routes/TemplateListPage";
import ReportListPage from "./routes/ReportListPage";


export default function App() {

  return (
    <div className="min-vh-100 d-flex flex-col flex-column">
      <Header />
      <Routes>
        <Route path={"/"} element={<>Home</>} />
        <Route path="/designer" element={<DesignerPage />} />
        <Route path="/designer/:id" element={<DesignerPage />} />
        <Route path="/form/:mode/:templateId/:reportId" element={<FormPage />} />
        <Route path="/form/:mode/:reportId" element={<FormPage />} />
        <Route path="/viewer/:reportId" element={<ViewerPage />} />
        <Route path="/template-list" element={<TemplateListPage />} />
        <Route path="/report-list" element={<ReportListPage />} />
      </Routes>
      <ToastContainer />
    </div>
  );
}
